export enum ControlType {
  YesCompliant = 'yescompliant',
  NoCompliant = 'nocompliant',
  AtLeast = 'atleast',
  AtMax = 'atmax',
  YesCompliantWithExpiryDate = 'yescompliantwithexpirydate',
  YesCompliantWithPastDate = 'yescompliantwithpastdate',
  MultiselectAtMax = 'multiselectatmax',
  SingleSelect = 'singleselect',
}

export type ExpiryControlMetadata = {
  expiryLabel: string;
};

export type MultiselectControlMetadata = {
  options: { id: string; emoji: string; label: string; groups: string[] }[];
};

export type SingleSelectControlMetadata = {
  options: { id: string; label: string }[];
};

export type ControlMetadata =
  | null
  | ({
      controlDomainType?: string;
    } & (ExpiryControlMetadata | MultiselectControlMetadata | SingleSelectControlMetadata));

export enum ControlParentRelationshipType {
  Additive = 'additive',
  Scoping = 'scoping',
}

export type Control = {
  controlID: string;
  domainID: string;
  levels: string[];
  number: number;
  question: string;
  description: string;
  controlType: ControlType;
  metadata: ControlMetadata;
  enumLabels: string[];
  parentID: string;
  ifParentAnswer: string;
  certifications?: string[]; // TODO: fix API and return empty array instead of null
  createdAt: string;
  modifiedAt?: string;
  deprecated: boolean;
  riskStatement: string;
  version: number;
  parentRelationshipType: ControlParentRelationshipType | null;
};

export type ControlBookmark = {
  id: string;
  orgID: string;
  controlID: string;
  bookmarked: boolean;
  modifiedAt: string;
  modifiedBy: string;
};

export type ScanTypeControlPair = {
  scanTypeID: string;
  controlID: string;
};
